import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

const PaymentCancel = () => {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-5">
      <div data-testid="payment-cancel-card" className="bg-white border border-neutral-200 rounded-2xl p-8 max-w-md w-full text-center shadow-sm">
        <XCircle className="w-14 h-14 text-neutral-500 mx-auto" />
        <h1 className="mt-4 text-2xl font-extrabold text-neutral-900">Payment cancelled</h1>
        <p className="mt-2 text-sm text-neutral-500">You closed the Stripe checkout. No money was charged.</p>
        <div className="mt-6 flex flex-col gap-2">
          <button data-testid="payment-cancel-home-btn" onClick={() => nav('/home')} className="w-full py-3 rounded-xl bg-[#2E7D32] hover:bg-[#276D2A] text-white font-bold">Back to home</button>
          <button onClick={() => nav(-1)} className="w-full py-3 rounded-xl bg-white border border-neutral-200 hover:border-[#2E7D32] font-bold inline-flex items-center justify-center gap-1.5">
            <ArrowLeft className="w-4 h-4" /> Go back
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;
